import { useEffect, useState } from 'react';
import { ChatPanel } from './ChatPanel';

interface Props {
  accountId: string;
}

export function ChatLauncher({ accountId }: Props) {
  const [open, setOpen] = useState(false);

  // Close on Escape so the modal feels like a normal dialog.
  useEffect(() => {
    if (!open) return;
    function onKey(e: KeyboardEvent) {
      if (e.key === 'Escape') setOpen(false);
    }
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open]);

  // Lock body scroll while the modal is open so the page behind doesn't
  // scroll under the user's fingers on mobile / trackpad.
  useEffect(() => {
    if (!open) return;
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = prev;
    };
  }, [open]);

  return (
    <>
      <button
        onClick={() => setOpen(true)}
        aria-label="Ask Claude"
        title="Ask Claude about your portfolio"
        style={{
          position: 'fixed',
          right: '1.5rem',
          bottom: '1.5rem',
          zIndex: 50,
          width: '3.75rem',
          height: '3.75rem',
          borderRadius: '50%',
          border: 'none',
          background: '#0f172a',
          color: 'white',
          fontSize: '1.6rem',
          cursor: 'pointer',
          boxShadow: '0 8px 20px rgba(15, 23, 42, 0.25)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        💬
      </button>

      {open && (
        <div
          role="dialog"
          aria-modal="true"
          aria-label="Ask Claude"
          onClick={() => setOpen(false)}
          style={{
            position: 'fixed',
            inset: 0,
            background: 'rgba(15, 23, 42, 0.45)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '1rem',
            zIndex: 100,
          }}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              background: 'white',
              borderRadius: '0.75rem',
              boxShadow: '0 20px 60px rgba(15, 23, 42, 0.35)',
              width: '100%',
              maxWidth: '720px',
              maxHeight: '90vh',
              display: 'flex',
              flexDirection: 'column',
              overflow: 'hidden',
            }}
          >
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '0.75rem',
                padding: '0.85rem 1.1rem',
                borderBottom: '1px solid #e2e8f0',
              }}
            >
              <div style={{ fontWeight: 700, fontSize: '1.05rem' }}>Ask Claude</div>
              <div style={{ flex: 1, fontSize: '0.85rem', color: '#64748b' }}>
                Sees your portfolio · can search the web for current news
              </div>
              <button
                onClick={() => setOpen(false)}
                aria-label="Close"
                style={{
                  background: 'transparent',
                  border: 'none',
                  fontSize: '1.5rem',
                  cursor: 'pointer',
                  color: '#64748b',
                  lineHeight: 1,
                }}
              >
                ×
              </button>
            </div>
            <div style={{ flex: 1, minHeight: 0, overflow: 'auto', padding: '1rem' }}>
              <ChatPanel accountId={accountId} />
            </div>
          </div>
        </div>
      )}
    </>
  );
}
